import { render, staticRenderFns } from "./wxalink.vue?vue&type=template&id=7a7b2cfc&scoped=true"
import script from "./wxalink.vue?vue&type=script&lang=js"
export * from "./wxalink.vue?vue&type=script&lang=js"
import style0 from "./wxalink.vue?vue&type=style&index=0&id=7a7b2cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.47.0__css-load_8b2b7732cc741d077553b84f33555b65/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7b2cfc",
  null
  
)

export default component.exports